import Link from 'components/Link'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Header from '../Header'
import RightCol from '../RightCol'
import CallToAction from '../CallToAction'
import { Block, TwoCol, Wrapper } from '../Wrapper'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import slugify from 'slugify'
import { Authentication, EditProfile } from 'components/Idengager'
import { useUser } from 'hooks/useUser'
import getAvatarURL from '../../../Idengager/util/getAvatar'

import {
    Websites,
    PropertyManagement,
    API,
    AppLibrary,
    DataManagement,
    EventPipelines,
    RealestateMarketing,
    TransactionManagement,
    MobileApps,
    StakeholderManagement,
    Integrations,
    Projects,
    RealestateCrm,
    UserPermissions,
    Notifications,
    Listingshub,
} from 'components/ProductIcons'
import {
    HowiCloudReadyWorks,
    IdentifyUsers,
    Migrate,
    JSSnippet,
    Privacy,
    Quickstart,
    SDK,
    Tutorials,
    Webhooks,
} from 'components/NotProductIcons'

interface IFeature {
    title: string
    icon: React.ReactNode
    url: string
}

interface IColumn {
    title: string
    section: IFeature[]
    className?: string
}

export const Login = ({ onSubmit = () => undefined }: { onSubmit?: () => void }) => {
    const [state, setState] = useState<null | 'login' | 'signup'>(null)

    return state === 'login' ? (
        <>
            <p className="m-0 text-sm font-bold dark:text-white">
                Note: icloud-ready.com authentication is separate from your iCloudReady app.
            </p>
            <p className="my-2 text-sm dark:text-white">
                We suggest signing up with your personal email. Soon you'll be able to link your iCloudReady app
                account.
            </p>
            <Authentication showBanner={false} showProfile={false} />
        </>
    ) : state === 'signup' ? (
        <>
            <p className="m-0 text-sm font-bold dark:text-white">
                Note: icloud-ready.com authentication is separate from your iCloudReady app.
            </p>
            <p className="my-2 text-sm dark:text-white">
                We suggest signing up with your personal email. Soon you'll be able to link your iCloudReady app
                account.
            </p>
            <Authentication initialView="sign-up" showBanner={false} showProfile={false} />
        </>
    ) : (
        <>
            <p className="m-0 text-sm dark:text-white">
                Your icloud-ready.com support profile lets you ask questions and get early access to beta features.
            </p>
            <p className="my-2 rounded bg-gray-accent-light p-2 text-[13px] dark:bg-gray-accent-dark dark:text-white">
                <strong>Tip:</strong> If you've ever asked a question on icloud-ready.com, you already have an account!
            </p>
            <CallToAction onClick={() => setState('login')} width="full" size="sm">
                Login to icloud-ready.com
            </CallToAction>
            <CallToAction onClick={() => setState('signup')} width="full" type="secondary" size="sm" className="mt-2">
                Create an account
            </CallToAction>
        </>
    )
}

export const Avatar = (props: { className?: string; src?: string }) => {
    return (
        <div className={`overflow-hidden rounded-full ${props.className}`}>
            {props.src ? (
                <img className="h-full w-full" alt="" src={props.src} />
            ) : (
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M20.0782 41.0392H5.42978C4.03134 41.0392 3.1173 40.1642 3.09386 38.7736C3.07823 37.7814 3.07042 36.797 3.10948 35.8048C3.15636 34.6329 3.72668 33.7345 4.74228 33.1798C8.0782 31.3595 11.4299 29.5783 14.7659 27.7658C15.0081 27.633 15.1565 27.758 15.3362 27.8517C18.1878 29.3439 21.0942 29.4689 24.0626 28.2267C24.1485 28.1955 24.2423 28.1721 24.3126 28.1096C24.9298 27.5861 25.4845 27.7971 26.1251 28.1486C29.1173 29.7971 32.1331 31.4143 35.1487 33.0238C36.4534 33.7191 37.094 34.766 37.0706 36.2426C37.0549 37.0785 37.0706 37.9067 37.0706 38.7426C37.0628 40.1254 36.1409 41.0395 34.7659 41.0395H20.0783L20.0782 41.0392Z"
                        fill="#BFBFBC"
                    />
                    <path
                        d="M19.8359 27.0625C17.0859 26.9687 14.8047 25.6094 13.1251 23.1953C10.3751 19.2344 10.7032 13.6093 13.8516 10.0001C17.2735 6.08599 22.9452 6.10943 26.336 10.0469C29.9376 14.2345 29.711 20.8437 25.8126 24.6405C24.2188 26.1952 22.3126 27.0312 19.8362 27.0624L19.8359 27.0625Z"
                        fill="#BFBFBC"
                    />
                </svg>
            )}
        </div>
    )
}
const learn: IFeature[] = [
    { title: 'How to ?', icon: <JSSnippet />, url: '/tutorials' },
    { title: 'mobile apps', icon: <Quickstart />, url: '/tutorials' },
    { title: 'websites', icon: <EventPipelines />, url: '/tutorials' },
    { title: 'Academy', icon: <EventPipelines />, url: '/academy' },
    { title: 'Privacy', icon: <Privacy />, url: '/docs/privacy' },
]

const products: IFeature[] = [
    { title: 'Property management', icon: <PropertyManagement />, url: '/docs/property-management' },
    { title: 'Real estate crm', icon: <RealestateCrm />, url: '/docs/real-estate-crm' },
    { title: 'Real estate marketing', icon: <RealestateMarketing />, url: '/docs/real-estate-marketing' },
    { title: 'Mobile apps', icon: <MobileApps />, url: '/docs/real-estate-mobile-apps' },
    { title: 'Transaction management', icon: <TransactionManagement />, url: '/docs/transaction-management' },
    { title: 'Websites', icon: <Websites />, url: '/docs/websites' },
    { title: 'Analytics', icon: <Projects />, url: '/docs/analytics' },
    { title: 'Listing hub', icon: <Listingshub />, url: '/docs/listings-hub' },
]

const developer: IFeature[] = [
    { title: 'Tutorials', icon: <Tutorials />, url: '/tutorials' },
    { title: 'Integrations', icon: <Integrations />, url: '/docs/integrations' },
    { title: 'Dashboards', icon: <Notifications />, url: '/dashboards' },
    { title: 'API', icon: <API />, url: '/docs/api' },
    { title: 'SDK', icon: <SDK />, url: '/docs/sdk' },
    { title: 'Webhooks', icon: <Webhooks />, url: '/docs/webhooks' },
]

const categories: IColumn[] = [
    {
        title: 'Learn',
        section: learn,
        className: '',
    },
    {
        title: 'Products',
        section: products,
        className: '',
    },
    {
        title: 'Developer',
        section: developer,
        className: '',
    },
]

const Section = ({ title, section, className = '' }: IColumn) => {
    return (
        <ul className={`m-0 list-none space-y-2 p-0 ${className}`}>
            <h5 className="m-0 border-b border-dashed border-gray-accent-light pb-1 text-[15px] font-semibold opacity-40">
                {title}
            </h5>
            <ul className="m-0 grid list-none grid-cols-3 gap-2 p-0 dark:text-primary-dark md:grid-cols-7">
                {section.map(({ title, icon, url }, index) => {
                    return (
                        <li key={index} className="w-[6.5rem]">
                            <Link
                                to={url}
                                className="relative flex h-full flex-col items-center gap-2 rounded p-2 text-center text-[14px] font-semibold leading-tight hover:scale-[1.02] hover:bg-gray-accent-light/50 active:top-[1px] active:scale-[1] dark:hover:bg-gray-accent-light/25"
                            >
                                <div className="flex h-6 w-6 items-center justify-center">{icon}</div>
                                <span>{title}</span>
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </ul>
    )
}

interface ColMenuItems {
    title: string
    description: string
    url: string
}

const Profile = () => {
    const { user } = useUser()
    const profile = user?.profile

    return profile ? (
        <div>
            <div className="mt-4 mb-3 flex items-center space-x-2">
                <Avatar src={getAvatarURL(profile)} className="h-[40px] w-[40px]" />
                <div>
                    {
                        <p className="m-0 font-semibold dark:text-white">
                            {[profile.firstName, profile.lastName].filter(Boolean).join(' ')}
                        </p>
                    }
                </div>
            </div>
            <CallToAction to={`/support/profiles/${profile?.id}`} className="!w-full" size="xs" type="secondary">
                Visit profile
            </CallToAction>
        </div>
    ) : (
        <Login onSubmit={() => navigate('/support')} />
    )
}

export default function Docs({ referenceElement }: { referenceElement: HTMLDivElement }) {
    const {
        topicGroups,
        questions: { allCustomerSupportTopics },
    } = useStaticQuery(query)
    // {"topicGroups":{"nodes":[{"label":"On-permiseing","topics":[{"id":"b4127e0b-227d-55a1-a87b-68115561dc02","label":"Deployment"},{"id":"27f7801b-2314-5cfb-b9ab-50f1e3288c57","label":"Migration"}]},{"label":"Products","topics":[{"id":"8f9b4abf-4e1d-53e9-a29d-29ac31a75a64","label":"Property management"},{"id":"752f4508-5651-5311-a346-11ecca3069d9","label":"Session replay"},{"id":"15369cf8-0e8b-5b70-982c-fef39df621b8","label":"Feature flags"},{"id":"2411dbc1-1851-5bfb-a7a4-392a62ec13cf","label":"A/B testing"}]},{"label":"Other","topics":[{"id":"aa45467f-4d4d-5463-a033-bec652878d03","label":"Uncategorized"}]},{"label":"Data","topics":[{"id":"198d8dc4-21a7-5711-809d-f1a459405895","label":"Groups"},{"id":"8841b8f0-c706-55cc-95c6-1d154b9a3829","label":"People & properties"},{"id":"5202706c-df0a-5a5a-a711-b8f7ac58d200","label":"Events & actions"}]},{"label":"Platform","topics":[{"id":"a84d3b56-32ed-5f7a-85d2-f95089bf3d00","label":"API"},{"id":"a93e38d2-a589-5b3f-a0d3-76c43c369ddd","label":"Apps"},{"id":"4e79c01d-7b83-5d13-8831-668dd80aca1b","label":"Configuration"},{"id":"902308ab-872b-5536-8442-ca239b1ccb16","label":"Toolbar"},{"id":"694a8d26-26e3-55ce-b493-c3e6fa1153f4","label":"Pricing & billing"},{"id":"fcbed9b9-02be-571c-bf98-9b05f79717f1","label":"Dashboards"},{"id":"279f045f-4c7f-59b5-ba0a-da2a7869d6a4","label":"Real Estate pipelines"}]}]},"questions":{"allTopics":[{"topic":"A/B testing","count":1},{"topic":"API","count":8},{"topic":"Apps","count":11},{"topic":"Bugs","count":2},{"topic":"Cohorts","count":5},{"topic":"Configuration","count":3},{"topic":"Dashboards","count":2},{"topic":"Deployment","count":15},{"topic":"Real Estate pipelines","count":8},{"topic":"Events & actions","count":10},{"topic":"Feature flags","count":6},{"topic":"Funnels","count":2},{"topic":"GCP","count":1},{"topic":"Groups","count":1},{"topic":"Heatmaps","count":1},{"topic":"Helm chart","count":3},{"topic":"Iframes","count":1},{"topic":"Internal: Follow-up","count":7},{"topic":"Kubernetes","count":2},{"topic":"Migration","count":2},{"topic":"More","count":2},{"topic":"Paths","count":2},{"topic":"People & properties","count":5},{"topic":"Pricing & billing","count":5},{"topic":"Property management","count":25},{"topic":"Retention","count":1},{"topic":"SDKs","count":1},{"topic":"Session replay","count":22},{"topic":"Sessions","count":3},{"topic":"Toolbar","count":1},{"topic":"Trends","count":2},{"topic":"Uncategorized","count":305},{"topic":"Versus other tools","count":1}]}}
    const resources: ColMenuItems[] = [
        {
            title: 'Product roadmap',
            description: "See what we're building, and help us decide what to build next.",
            url: '/roadmap',
        },
        // {
        //     title: 'Contributors',
        //     description: 'Fix a bug, get credit for the giveaways store (and warm fuzzies)',
        //     url: '/partners',
        // },
        // {
        //     title: 'Issues',
        //     description: 'Browse recent issues on GitHub',
        //     url: 'https://github.com/icloud-ready/icloudready/issues',
        // },
        // {
        //     title: 'Get involved',
        //     description: 'Explore “good first issues” on GitHub',
        //     url: 'https://github.com/icloud-ready/icloudready/issues?q=is%3Aopen+is%3Aissue+label%3A%22good+first+issue%22',
        // },
        {
            title: 'Slack support',
            description: 'Chat in realtime with the team and other support members',
            url: '/slack',
        },
        {
            title: 'Browse recent questions or Ask a question',
            description:
                'Ask and answer support questions about iCloudReady. These questions are posted across icloud-ready.com and aggregated here',
            url: '/questions',
        },
        // {
        //     title: 'iCloudReady FM',
        //     description: 'An ever-evolving selection of the iCloudReady team’s top tracks',
        //     url: 'https://open.spotify.com/playlist/7A2H2J3WhpJmMEwAhKahWH?si=47418915a8d0447b',
        // },
    ]

    const topicGroupsToShow = ['Product features', 'Setup & platform']

    return (
        <Wrapper referenceElement={referenceElement} placement="bottom-end">
            <section className="flex flex-col-reverse md:flex-col">
                <Header title="Support" />
                <div className="p-5 md:flex md:p-0">
                    <div className="w-full border-dashed border-gray-accent-light md:w-[500px] md:border-r lg:w-[650px]">
                        {/* <div className="md:p-6 lg:px-9 md:pr-3 md:mb-0 mb-4">
                            <div>
                                <div className="flex justify-between items-center mr-2">
                                    <h3 className="text-[18px] opacity-70 m-0 md:mr-6 text-black">
                                        Support questions
                                    </h3>
                                    <CallToAction to="/questions">Ask a question</CallToAction>
                                </div>
                                <p className="mt-4 dark:text-white">
                                    Ask and answer support questions about iCloudReady. These questions are posted across
                                    icloud-ready.com and aggregated here.
                                </p>
                                <ul className="grid grid-cols-2 m-0 p-0 list-none mt-2 gap-x-6">
                                    {topicGroups.nodes
                                        .filter((node) => topicGroupsToShow.includes(node.label))
                                        .map(({ label, topics }) => {
                                            return (
                                                topics.length > 0 && (
                                                    <li>
                                                        <h3 className="text-base opacity-70 m-0 md:mr-6 text-black">
                                                            {label}
                                                        </h3>
                                                        <ul className="list-none m-0 p-0 mt-2 ">
                                                            {topics
                                                                .sort((a, b) => {
                                                                    return (
                                                                        allCustomerSupportTopics.find(
                                                                            (topic) => topic.topic === b.label
                                                                        )?.count -
                                                                        allCustomerSupportTopics.find(
                                                                            (topic) => topic.topic === a.label
                                                                        )?.count
                                                                    )
                                                                })
                                                                .slice(0, 4)
                                                                .map(({ label }) => {
                                                                    return (
                                                                        <li
                                                                            className="last:border-b-0 py-2 border-b border-dashed border-gray-accent-light dark:border-gray-accent-dark"
                                                                            key={label}
                                                                        >
                                                                            <Link
                                                                                className="text-sm font-bold text-red flex w-full space-x-2"
                                                                                to={`/questions/topics/${slugify(
                                                                                    label,
                                                                                    {
                                                                                        lower: true,
                                                                                    }
                                                                                )}`}
                                                                            >
                                                                                <span>{label}</span>
                                                                                <span className=" dark:text-white opacity-50 font-semibold">
                                                                                    (
                                                                                    {allCustomerSupportTopics.find(
                                                                                        (topic) => topic.topic === label
                                                                                    )?.count || '0'}
                                                                                    )
                                                                                </span>
                                                                            </Link>
                                                                        </li>
                                                                    )
                                                                })}
                                                        </ul>
                                                    </li>
                                                )
                                            )
                                        })}
                                </ul>
                            </div>

                            <div className="md:mr-2 mt-2">
                                <CallToAction to="/questions" className="!w-full mt-4">
                                    Browse recent questions
                                </CallToAction>
                            </div>
                        </div> */}

                        {/* <div className="border-t border-gray-accent-light border-dashed">
                            <div className="max-w-3xl mx-auto xl:max-w-auto">
                                <Block title="Roadmap" cta={{ url: '/roadmap', label: 'Browse roadmap' }}>
                                    <p className="m-0 text-[14px] dark:text-white">
                                        See what we're building, and help us decide what to build next.
                                    </p>
                                </Block>
                            </div>
                        </div> */}
                        <div className="space-y-4 rounded-md px-8 py-6">
                            {categories.map((section, index) => {
                                return <Section key={index} {...section} />
                            })}
                        </div>
                        {/* <h3 className="text-lg font-bold mb-4 text-primary dark:text-primary-dark">
                    <Link to="/docs" className="hover:text-red">
                    Docs
                    </Link>
                </h3> */}
                        <section className="flex flex-col border-r border-dashed border-gray-accent-light p-6">
                            <CallToAction className="mt-auto inline-block !w-full" to="/docs">
                                Browse all Docs
                            </CallToAction>
                        </section>

                        {/* <div className="py-7 md:px-6 lg:px-9 border-t md:border-b-0 border-b md:mb-0 mb-4 border-gray-accent-light border-dashed">
                            <div className="grid sm:grid-cols-2 items-center">
                                <div>
                                    <h3 className="text-[18px] opacity-70 mt-0 text-black">Docs</h3>
                                    <p className="text-[14px] dark:text-white">
                                    See our docs, and learn every details you may need.
                                    </p>
                                </div>
                            </div>
                            <CallToAction to="/docs" className="!w-full mt-4">
                                Browse our docs
                            </CallToAction>
                        </div> */}

                        {/* <div className="py-7 md:px-6 lg:px-9 border-t md:border-b-0 border-b md:mb-0 mb-4 border-gray-accent-light border-dashed">
                            <div className="grid sm:grid-cols-2 items-center">
                                <div>
                                    <h3 className="text-[18px] opacity-70 mt-0 text-black">Giveaways</h3>
                                    <p className="text-[14px] dark:text-white">
                                        Did you happen to be looking for hedgeready-themed giveaways? We've got just the
                                        thing...
                                    </p>
                                </div>
                                <div>
                                    <StaticImage
                                        className="pointer-events-none"
                                        width={280}
                                        alt="iCloudReady giveaways"
                                        src="../../images/giveaways.png"
                                    />
                                </div>
                            </div>
                            <p className="text-[14px] dark:text-white">
                                P.S. Get free giveaways by{' '}
                                <Link className="text-red hover:text-red font-bold" to="https://github.com/icloud-ready">
                                    contributing
                                </Link>{' '}
                                or{' '}
                                <Link className="text-red hover:text-red font-bold" to="/questions">
                                    answering support questions
                                </Link>
                                .
                            </p>
                            <CallToAction to="https://giveaways.icloud-ready.com" className="!w-full mt-4">
                                Visit the giveaways store
                            </CallToAction>
                        </div> */}
                    </div>
                    <RightCol title="My support profile">
                        <div className="px-3">
                            <div className="mb-6">
                                <Profile />
                            </div>
                        </div>
                        <ol className="m-0 list-none p-0">
                            {resources.map(({ title, description, url }: ColMenuItems, index2) => {
                                return (
                                    <li key={index2}>
                                        <Link
                                            className="relative block rounded-sm py-2 px-3 hover:bg-tan/50 active:top-[1px] active:scale-[.99]"
                                            to={url}
                                        >
                                            <h3 className="m-0 text-base  opacity-70">{title}</h3>
                                            <p className="m-0 text-sm font-medium  opacity-50 dark:text-white">
                                                {description}
                                            </p>
                                        </Link>
                                    </li>
                                )
                            })}
                        </ol>
                    </RightCol>
                </div>
            </section>
        </Wrapper>
    )
}

const query = graphql`
    {
        topicGroups: allCustomerSupportTopicGroup {
            nodes {
                label
                topics {
                    id
                    label
                }
            }
        }
        questions: allCustomerSupportQuestion {
            allCustomerSupportTopics: group(field: topics___label) {
                topic: fieldValue
                count: totalCount
            }
        }
    }
`
